import { render, staticRenderFns } from "./PosReportCashier.vue?vue&type=template&id=b3a0f042"
import script from "./PosReportCashier.vue?vue&type=script&lang=js"
export * from "./PosReportCashier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports